import { ModalWindow, JsonViewer, RefSerializer, Button, ButtonTabs, MultilineInput, RefString, Div, Text, Snack } from "@tblabs/truffle";
import { Device } from "../Services/Device";
import { JsonValidator } from "../Utils/JsonValidator";


export class DeviceRecordWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super(`💽 ${device.Id} Database record`, true, true, true);
        this.WidthPercent(90)

        const asObj = RefSerializer.Flatenize(device.Record);
        const eidtable = new RefString(JSON.stringify(asObj, null, 4));
        const validator = new JsonValidator(eidtable);

        const tab = new RefString("Read");
        const tabs = new ButtonTabs(tab)
            .Add('Read', () => new JsonViewer(asObj).Background("#fff").Padding(16))
            .Add('Edit', () => new Div().Append(
                new MultilineInput(eidtable).Rows(8).Background("#fff").Padding(16),
                new Text(validator.Message),
            ))

        this.AddContent(
            tabs,
        );

        this.AddToFooter(
            new Button("Update record").Class("uk-button uk-button-primary").FloatLeft()
                .Enable(validator.IsValid)
                .VisibleWhen(tab, v => v == "Edit")
                .OnClick(() =>
                {
                    device.Record = JSON.parse(eidtable.value);
                    device._server.UpdateDeviceRecord(device.Id, device.Record);
                    new Snack("Record update", "Command sent", { autoCloseTimeout: 2000, clickAnywhereToClose: true });
                }),
            new Button("Close", () => this.CloseWindow())
        );

        this.OpenWindow();
    }
}
